export var PAGE_NAME = {
    ERROR: "error",
    VIEW: "view statements",
    API_FAILED: "api failed",
    REENROLLMENT_FAILED: "failed",
    UNENROLLED_NO_STATEMENTS_API_FAIL: "no statements api failed",
    NO_STATEMENTS: "no statements",
    DELINQUENT_STATUS: "delinquent account status",
};
export var DEFAULTS = {
    SUB_FUNCTION: "",
    PAGE_FUNCTION: "statements",
    PAGE_NAME: "",
    SITE_IDENTIFIER: "vista",
    DEVICE: "<mobi/desk/tab>",
    PNL: "vista",
    CUSTOMER_TYPE: "consumer",
    PRODUCT: "generic",
    ERROR_MESSAGE: "",
    MESSAGE: "",
    PAGE_KIND: "statements",
};
